import { h } from 'preact'

const BetaBadge = () => {
  return <div class='beta-badge'>BETA</div>
}

export default BetaBadge
